module.exports = __webpack_public_path__ + "img/autoral.89e42c6f.svg";